import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8.654a8.654 8.654 0 1 0 0 17.308 8.654 8.654 0 0 0 0-17.308",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M15.058 12a9.97 9.97 0 0 1 3-7.141L19 5.82A8.63 8.63 0 0 0 16.404 12c0 2.421.993 4.609 2.596 6.18l-.942.962a9.97 9.97 0 0 1-3-7.142M8.942 12c0-2.75-1.153-5.235-3.004-7.014l-.933.97C6.607 7.496 7.596 9.635 7.596 12s-.99 4.504-2.591 6.043l.933.971C7.789 17.234 8.942 14.75 8.942 12M12 2c.372 0 .673.301.673.673v18.654a.673.673 0 0 1-1.346 0V2.673c0-.372.301-.673.673-.673",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M22 12a.673.673 0 0 0-.673-.673H2.673a.673.673 0 1 0 0 1.346h18.654A.673.673 0 0 0 22 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }